import { Sparkles, FileText, Search } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef, TextFieldDef } from '@/components/admin/SectionPageEditor';

// pages/terms-of-service/page.tsx is 10 numbered sections, each a plain
// title+body pair (verified directly against the page's `sections`
// array) — generated below rather than hand-listed. All 23 keys
// (3 hero + 20 section) are live, no orphans. No images on this page.
function legalSections(namespace: string, count: number): TextFieldDef[] {
  const fields: TextFieldDef[] = [];
  for (let i = 1; i <= count; i++) {
    fields.push({ key: `${namespace}.section${i}.title`, label: `Section ${i} — Title` });
    fields.push({ key: `${namespace}.section${i}.body`, label: `Section ${i} — Body`, long: true });
  }
  return fields;
}

const TERMS_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'terms.hero.label', label: 'Eyebrow Label' },
      { key: 'terms.hero.heading', label: 'Heading' },
      { key: 'terms.lastUpdated', label: 'Last Updated Text' },
    ],
  },
  {
    key: 'legalContent',
    title: 'Legal Content (10 sections)',
    icon: FileText,
    texts: legalSections('terms', 10),
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.terms.title', label: 'Meta Title', long: true },
      { key: 'seo.terms.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminTermsPage() {
  return <SectionPageEditor pageKey="terms" title="Terms of Service" sections={TERMS_SECTIONS} />;
}
